// extracted by mini-css-extract-plugin
export default {"button":"_2L2uXHR5_T_3FD68M1mwi3"};